import { PossibleNodeTypes, NodeType } from './types';

export const detectNodeType = (value: PossibleNodeTypes): NodeType => {
  if (Array.isArray(value)) {
    return NodeType.array;
  }

  if (typeof value === 'number') {
    return NodeType.number;
  }

  if (typeof value === 'boolean') {
    return NodeType.boolean;
  }

  if (typeof value === 'string') {
    return NodeType.string;
  }

  if (value === null) {
    return NodeType.null;
  }

  return NodeType.object;
};
